/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ProductDraftsUserControllerCreateMutationRequest,
  ProductDraftsUserControllerCreateMutationResponse,
  ProductDraftsUserControllerCreate400,
  ProductDraftsUserControllerCreate401,
  ProductDraftsUserControllerCreate409,
} from '../types/ProductDraftsUserControllerCreate.ts';

function getProductDraftsUserCreateUrl() {
  const res = { method: 'POST', url: `/api/user/product-drafts` as const };
  return res;
}

/**
 * {@link /api/user/product-drafts}
 */
export async function productDraftsUserCreate(
  data?: ProductDraftsUserControllerCreateMutationRequest,
  config: Partial<RequestConfig<ProductDraftsUserControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    ProductDraftsUserControllerCreateMutationResponse,
    ResponseErrorConfig<
      ProductDraftsUserControllerCreate400 | ProductDraftsUserControllerCreate401 | ProductDraftsUserControllerCreate409
    >,
    ProductDraftsUserControllerCreateMutationRequest
  >({ method: 'POST', url: getProductDraftsUserCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
